import type { RouteLocationRaw } from "vue-router";

export const useReturnToLink = () => {
  const route = useRoute();

  const withReturnTo = (href?: string | null): RouteLocationRaw | undefined => {
    if (typeof href !== "string") return undefined;

    const trimmed = href.trim();
    if (!trimmed.startsWith("/")) return undefined;

    const url = new URL(trimmed, "http://local");
    const query: Record<string, string> = {};

    url.searchParams.forEach((value, key) => {
      query[key] = value;
    });

    query.returnTo = route.fullPath;

    return {
      path: url.pathname,
      query,
      hash: url.hash || undefined,
    };
  };

  return {
    withReturnTo,
  };
};
